class Header {
    constructor(el) {
        this.scope = el;
        this.logo = el.querySelector("[data-header-logo]");
        this.buttons = el.querySelectorAll("[data-header-buttons] .button");
        this.burger = el.querySelector("[data-burger]");
        this.primaryLinks = el.querySelectorAll("[data-primary-link]");
        this.backLinks = el.querySelectorAll("[data-back]");
        this.closeLinks = el.querySelectorAll("[data-close]");
        this.headerTop = el.querySelector("[data-header-top]");
        
        this.navigations = el.querySelectorAll("[data-navigation]");
        
        this.navOpen = false;
        
        this.resizeId = null;
        this.scrollId = null;
        this.isDesktop = this.checkIfDesktop();
        this.internal = false;

        this.bindTab = (e) => {
            if ((e.key === "Tab") && !e.target.closest("[data-header]")) {
                this.toggleNav();
            }
            if ((e.key === "Tab") && !e.target.closest("[data-navigation]")) {
                if(this.isNavOpen()){
                    this.scope.querySelector("[data-primary-nav] [data-open]").removeAttribute("data-open");
                }
            }
        };
        this.bindEvents();
        this.waitForScroll();
    }

    bindEvents(){
        this.scope.querySelectorAll(".header__bottom__nav__links__item--active").length > 0 && this.scope.classList.add("header--active");
        window.addEventListener("resize", ()=> {
            this.waitForResize();
        });
        this.burger.addEventListener("click", ()=> this.toggleNav());
        this.primaryLinks.forEach(link=>{
            link.addEventListener("click", ()=> {
                link.parentNode.setAttribute("data-open", "");
                if(this.scope.classList.contains("header--has-tag-line")){
                    if((viewport() < 1) && (window.scrollY < 32)){
                        this.scope.style.setProperty('--header-offset', `${32 - window.scrollY}px`);
                    }else{
                        this.scope.style.removeProperty('--header-offset');
                    }
                }
            });
        })
        this.backLinks.forEach(link=>{
            link.addEventListener("click", ()=>{
                if(link.closest("[data-details]")){
                    console.log("1");
                    link.closest("[data-details]").open = false;
                }else if(link.closest("[data-open]")){
                    console.log("2");
                    console.log(link.closest("[data-open]"));
                    link.closest("[data-open]").removeAttribute("data-open");
                }else if (link.closest(".header__bottom__nav__links__item--active")){
                    console.log("3");
                    link.closest(".header__bottom__nav__links__item--active").classList.remove("header__bottom__nav__links__item--active")
                }
            });
        })
        this.closeLinks.forEach(close => {
            close.addEventListener('click', () => {
                if(viewport() > 2){
                    document.querySelector("html").classList.remove("overlay");
                    document.querySelector("html").classList.remove("nav-open");   
                }
                this.scope.querySelectorAll('[data-details]').forEach(details => {
                   details.parentElement.classList.remove("navigation__items__item--open");
                });
                this.scope.querySelectorAll('.navigation').forEach(navigation => {
                    navigation.classList.remove('navigation--open');
                });
            });
        });        

        this.navigations.forEach(nav=>{
            //single link height
            let navHeight = nav.querySelectorAll("li")[1].offsetHeight;
            nav.addEventListener("open", ()=>{
                //if more than 1 row of links
                if(nav.offsetHeight !== navHeight){
                    this.scope.style.setProperty('--nav-offset-height', `${nav.offsetHeight}px`);
                }
            })
        })
        if(!!this.headerTop){
            window.addEventListener("scroll", ()=> {
                if(viewport() <= 2) {
                    this.waitForScroll();
                }
            });   
        }
    }

    waitForResize(){
        clearTimeout(this.resizeId);
        this.resizeId = setTimeout(() => {
            if(this.checkIfDesktop() !== this.isDesktop){
                this.navOpen && this.toggleNav();
                if(viewport() > 2){
                    document.querySelector("html").classList.remove("overlay");
                    document.querySelector("html").classList.remove("nav-open");   
                }
                this.isDesktop = this.checkIfDesktop();
            }
        }, 300);
    }

    waitForScroll() {
        clearTimeout(this.scrollId);
        this.scrollId = setTimeout(() => {
            if (this.headerTop && this.scope) {
                const headerHeight = this.headerTop.offsetHeight;
                const scrolledPast = window.scrollY > headerHeight;

                if (scrolledPast) {
                    this.scope.style.setProperty('--header-top-offset', '0px');
                } else {
                    this.scope.style.removeProperty('--header-top-offset');
                }
            } else {
                console.warn("Missing this.headerTop or this.scope");
            }
        }, 300);
    }

    isNavOpen(){
        let NavOpen = false;
        this.navigations.forEach(nav=>{
            if(nav.closest("[data-open]")){
                NavOpen = true;
            }
        })
        return NavOpen;
    }

    checkIfDesktop(){
        return viewport() > 2;
    }

    toggleNav(){
        this.navOpen = !this.navOpen;
        this.scope.classList.toggle("header--open", this.navOpen);
        document.querySelector("html").classList.toggle("overflow-hidden", this.navOpen);
        this.scope.querySelectorAll("[data-open]").length > 0 &&
        this.scope.querySelector("[data-open]").removeAttribute("data-open");
        this.scope.querySelectorAll(".navigation__items__item--open").length > 0 &&
        this.scope.querySelector(".navigation__items__item--open").classList.remove("navigation__items__item--open");
        if(this.navOpen){
            document.addEventListener("keyup", this.bindTab);
            if(viewport() < 2 && this.primaryLinks.length === 1 && this.primaryLinks[0].parentElement.classList.contains("header__bottom__nav__links__item--hide-label")){
              this.primaryLinks[0].parentElement.setAttribute("data-open", "");
            }
            if(this.primaryLinks.length > 0 ){
                this.primaryLinks[0].focus();
            }
            this.burger.setAttribute("title", "Close Menu");
            this.burger.setAttribute("aria-label", "Close Menu");
        } else {
            this.scope.querySelectorAll("[data-navigation]").forEach(nav =>{
                nav.navigation.closeMegaNav();
            })
            this.burger.setAttribute("title", "Open Menu");
            this.burger.setAttribute("aria-label", "Open Menu");
        }
    }

}

ControlBinders.register(`[data-header]`, el => new Header(el));